import { DASH_UNDERSCORE_WITH_FOLLOWING_LETTER_RE_GEN } from 'common/regex';

/*
  Formats objects with snake_case keys to camelCase keys. Does not impact the values.
  This is recursive and will transform the entire object.
  This is meant for simple objects coming from JSON responses. (nothing crazy like Date()'s).
*/
export function dashOrSnakeCaseToCamelCaseDeep(snakeCaseData) {

  if (Array.isArray(snakeCaseData)) {
    return snakeCaseData.map(val => {
      // If object or array recursively check for more non-camelCase keys
      if (typeof val === 'object' && val !== null) {
        return dashOrSnakeCaseToCamelCaseDeep(val);
      }
      return val;
    });

  } else if (typeof snakeCaseData === 'object' && snakeCaseData !== null) {
    const camelCaseObject = {};
    Object.keys(snakeCaseData).forEach(key => {

      let newKey;
      if (key.length <= 1) {
        // If the key isn't more than 1 character, leave as is.
        newKey = key;
      } else if (key) {
        // Replace letters preceeded by '-' or '_' with their uppercase form. Handles multiple underscores & dashes if present.
        newKey = key.replace(DASH_UNDERSCORE_WITH_FOLLOWING_LETTER_RE_GEN(), (_, x) => x.toUpperCase());
      }

      camelCaseObject[newKey] = dashOrSnakeCaseToCamelCaseDeep(snakeCaseData[key]);
    });

    return camelCaseObject;
  }

  return snakeCaseData;
}

/**
    Attempts to parse a string into a data structure.
    This is not currently built for anything else that JSON.parse can parse,
    but it should act accordingly (for example, taking string "true" or "false" values)

    @param {string} string The string that we'll attempt to JSON.parse
    @param {*} [returnValue=null] An optional default return when the method triggers a catch
*/
export const tryParse = (string, returnValue = null) => {
  try {
    return JSON.parse(string);
  } catch (e) {
    return returnValue; // returns an optional argument, or defaults to null
  }
};
